module.exports = __webpack_public_path__ + "img/0007.4816a73d.jpg";